<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Partner</mat-label>
      <mat-select
        placeholder="Vælg partner"
        aria-label="Partner"
        [formControl]="partnerCtrl"
        (selectionChange)="partnerSelected($event.value)"
        >
        @for (partner of partners; track partner) {
          <mat-option [value]="partner">
            {{ partner.partner.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>
